<template>
  <div :class="['survey__wrapper', { '-active': isActive }]" @click="$emit('click')">
    <div class="header">
      <div class="detail">
        <div>
          <strong>{{ message_payload }}</strong>
          <v-chip v-if="isDefault" color="primary" outline small style="font-size: 12px">{{
            $t('set_default')
          }}</v-chip>
        </div>
        <small>{{ $t('update_at') }}: {{ updatedAt | DateFormat('DD/MM/YYYY hh:mm A') }}</small>
      </div>
      <div class="action">
        <v-btn icon outline color="primary" class="ma-0" @click.stop="isExpand = !isExpand">
          <em
            :class="['fas', { 'fa-chevron-down': !isExpand }, { 'fa-chevron-up': isExpand }]"
          ></em>
        </v-btn>
        <v-btn icon outline color="primary" class="ma-0" @click.stop="handleEdit">
          <v-icon small>edit</v-icon>
        </v-btn>
      </div>
    </div>
    <template v-if="isExpand">
      <v-divider class="my-2"></v-divider>
      <v-layout fill-height wrap @click.stop>
        <v-flex
          :class="['form-control d-flex mb-2', { 'has-error': errors.has('messageText') }]"
          xs12
          style="flex-direction: column"
        >
          <label class="mb-1">
            {{ $t('Response Message') }}
          </label>
          <AutoResizeTextarea
            v-model="message_payload"
            v-validate="`max:${messageMaxLength}|required`"
            name="messageText"
            :maxlength="messageMaxLength"
            style="margin: 0 0 4px"
            :data-vv-as="$t('Response Message')"
            :data-vv-name="'messageText'"
            :placeholder="$t('Response Message')"
            :disabled="!isEdit"
          />
          <small style="margin-left: auto; font-size: 12px"
            >({{ messageLength }} / {{ messageMaxLength }})</small
          >
          <span v-show="errors.has('messageText')" class="text-error"
            >{{ errors.first('messageText') }}
          </span>
        </v-flex>
        <v-flex
          :class="['form-control d-flex mb-2', { 'has-error': errors.has('buttonName') }]"
          xs12
          style="flex-direction: column"
        >
          <label class="mb-1">
            {{ $t('Button Name') }}
          </label>
          <input
            v-model="button_name_payload"
            v-validate="`max:${buttonNameMaxLength}|required`"
            type="text"
            class="form-control"
            :maxlength="buttonNameMaxLength"
            name="buttonName"
            :data-vv-as="$t('Button Name')"
            :placeholder="$t('Button Name')"
            :disabled="!isEdit"
          />
          <div class="d-flex" style="justify-content: space-between">
            <span v-show="errors.has('buttonName')" class="text-error"
              >{{ errors.first('buttonName') }}
            </span>
            <small style="text-align: right; font-size: 12px"
              >({{ buttonNameLength }} / {{ buttonNameMaxLength }})</small
            >
          </div>
        </v-flex>
        <template v-if="isEdit">
          <v-layout justify-center wrap>
            <v-flex shrink class="px-1">
              <v-btn outline color="grey" @click.stop="isEdit = false">{{ $t('cancel') }}</v-btn>
            </v-flex>
            <v-flex shrink class="px-1">
              <v-btn depressed color="primary" @click.stop="handleSubmit">{{ $t('Save') }}</v-btn>
            </v-flex>
          </v-layout>
        </template>
      </v-layout>
    </template>
  </div>
</template>
<script>
import AutoResizeTextarea from '@/components/elements/AutoresizeTextarea'
import dayjs from 'dayjs'
export default {
  components: { AutoResizeTextarea },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    buttonName: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    createdAt: {
      type: String,
      default: ''
    },
    updatedAt: {
      type: String,
      default: ''
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      messageMaxLength: 640,
      buttonNameMaxLength: 20,
      showPreview: false,
      isExpand: false,
      message_payload: this.message,
      button_name_payload: this.buttonName
    }
  },
  computed: {
    messageLength() {
      return Number(this.message_payload.length)
    },
    buttonNameLength() {
      return Number(this.button_name_payload.length)
    }
  },
  methods: {
    handleEdit() {
      this.isEdit = true
      this.isExpand = true
    },
    handleSubmit() {
      try {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            this.goToErrorInput()
            return false
          }
          const payload = {
            is_default: this.isDefault,
            message: this.message_payload,
            button_name: this.button_name_payload,
            survey_id: this.surveyId,
            created_at: this.createdAt,
            updated_at: dayjs().format()
          }
          this.$emit('edit', payload)
          this.isEdit = false
          this.isExpand = false
          this.$validator.reset()
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.survey__wrapper {
  border: 1px solid #c1c1c1;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .detail {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      strong {
        color: #000;
      }
      small {
        color: #9e9e9e;
      }
    }
    .action {
      display: flex;
      flex-direction: row;
      gap: 8px;
      justify-content: flex-end;
      align-items: center;
    }
  }
  &.-active {
    border: 1px solid #ff846d;
    background: #fff0ee;
  }
  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/CustomerSupportService/SurveyCard.vue